import {
  getOrCreateSharedReferenceId,
  toSapExternalReferenceId,
} from '../call-log/cross-tab-call-guard.util';

export function generateCallReferenceId(cxoneContactId?: string | null): string {
  const contactId = cxoneContactId?.trim();
  if (contactId) {
    return getOrCreateSharedReferenceId(contactId);
  }
  return toSapExternalReferenceId(`CALL${Date.now()}`);
}

/** Prefer SAP display/business ID for CTI ContactID; fall back to UUID. */
export function resolveSapCtiContactId(contactId: string, displayId?: string): string {
  return displayId?.trim() || contactId;
}

export function formatPhoneForSAP(phone: string): string {
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 10) return phone;

  let countryCode: string;
  let areaCode: string;
  let exchange: string;
  let subscriber: string;

  if (digits.length === 10) {
    countryCode = '1';
    areaCode = digits.slice(0, 3);
    exchange = digits.slice(3, 6);
    subscriber = digits.slice(6, 10);
  } else if (digits.length >= 11) {
    countryCode = digits.slice(0, digits.length - 10);
    areaCode = digits.slice(-10, -7);
    exchange = digits.slice(-7, -4);
    subscriber = digits.slice(-4);
  } else {
    return phone;
  }

  return `+${countryCode} ${areaCode}-${exchange}-${subscriber}`;
}
